import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import AIAdvisor from './components/advisor/AIAdvisor';

import HomePage from './pages/Home';
import ShopPage from './pages/Shop';
import StoryPage from './pages/Story';
import TransparencyPage from './pages/Transparency';
import LoyaltyPage from './pages/Loyalty';
import JournalPage from './pages/Journal';
import ContactPage from './pages/Contact';
import SevagramPage from './pages/Sevagram';
import DashboardPage from './pages/Dashboard';
import PartnerPortalPage from './pages/PartnerPortal';
import AdminPage from './pages/Admin';
import ManufacturerPage from './pages/Manufacturer';
import SovereignDashboardPage from './pages/SovereignDashboard';
import PhilosophyPage from './pages/Philosophy';

function ScrollToTop() {
  const { pathname } = window.location;
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function App() {
  // The Sovereign Dashboard is an immersive, chrome-less surface — no
  // public header/footer/advisor leak into the founder's witness.
  const sovereignMode =
    typeof window !== 'undefined' &&
    window.location.pathname.startsWith('/admin/sovereign-dashboard');

  if (sovereignMode) {
    return (
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/admin/sovereign-dashboard" element={<SovereignDashboardPage />} />
            <Route path="*" element={<SovereignDashboardPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    );
  }

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main data-testid="main-content" className="min-h-screen">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/story" element={<StoryPage />} />
            <Route path="/philosophy" element={<PhilosophyPage />} />
            <Route path="/transparency" element={<TransparencyPage />} />
            <Route path="/sevagram" element={<SevagramPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/partners" element={<PartnerPortalPage />} />
            <Route path="/manufacturer" element={<ManufacturerPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/loyalty" element={<LoyaltyPage />} />
            <Route path="/journal" element={<JournalPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </main>
        <Footer />
        <AIAdvisor />
      </BrowserRouter>
    </div>
  );
}

export default App;
